/**
 * Corrections API
 * List and resolve corrections from the governance queue
 */

import { apiFetch } from './config';

export interface CorrectionItem {
  correction_id: string;
  status: 'recorded' | 'promoted' | 'rejected' | 'deferred';
  session_id: string;
  project_id: string;
  created_at: string;
  age_hours: number;
  email: string;
  original: string;
  corrected: string;
  note: string | null;
  file_context: string | null;
  matched_standard_id: string | null;
  matched_standard: {
    element: string;
    rule: string;
    maturity: string;
    category: string;
  } | null;
  defer_until: string | null;
  defer_reason: string | null;
  resolved_by: string | null;
  resolution_reason: string | null;
  reviewed_at: string | null;
  reviewer_maturity: string | null;
}

export interface CorrectionsListResponse {
  items: CorrectionItem[];
  total: number;
  status: string;
  counts: Record<string, number>;
}

export interface ResolvePayload {
  correction_id: string;
  action: 'promote' | 'reject' | 'defer';
  reason: string;
  defer_until?: string;
  override_action?: 'strengthen' | 'weaken' | 'replace' | 'add_exception';
}

export const correctionsApi = {
  list: async (status: string = 'recorded', limit: number = 50) => {
    const params = new URLSearchParams();
    params.set('status', status);
    params.set('limit', String(limit));
    return apiFetch<CorrectionsListResponse>(`/api/corrections?${params.toString()}`);
  },

  resolve: async (payload: ResolvePayload) => {
    return apiFetch<{ correction_id: string; action: string; status: string }>('/api/corrections/resolve', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
